import React, { useRef, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import * as htmlToImage from "html-to-image";
import toast from "react-hot-toast";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import html2canvas from "html2canvas";
import DownloadIcon from "../common/icon/DownloadIcon";
import ShareIcon from "../assets/icons/ShareIcon";
import i18n from "i18next";
import {
  handleFacebookShare,
  handleShare,
  handleSharePicture,
} from "../common/components/Common";
import { Urls } from "../constant/urls";

const EmployeeCardPreview = () => {
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isIOs, setIsIOs] = useState(false);
  const [pageData, setPageData] = useState([]);

  const domEl = useRef(null);
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    let platform = navigator?.userAgent || navigator?.platform || "unknown";
    if (/iPhone|iPod|iPad/.test(platform)) {
      setIsIOs(true);
    } else {
      setIsIOs(false);
    }
  }, []);
  useEffect(() => {
    if (!state) {
      navigate("/");
    }
  }, [state]);

  const downloadImageForAndroid = async () => {
    setLoading(true);
    try {
      const dataUrl = await htmlToImage.toPng(domEl.current, {
        skipAutoScale: true,
      });

      const link = document.createElement("a");
      link.download = "Greetings-card.png";
      link.href = dataUrl;
      link.click();
      setLoading(false);
      window.gtag("event", "DOWNLOAD_EMPLOYEE_CARD");
    } catch (err) {
      toast.error("Something went wrong.Please Try again.");
      setLoading(false);
    }
  };

  const downloadImageForiOs = () => {
    let data = document.getElementById("domEl");
    setLoading(true);
    html2canvas(data, {
      allowTaint: true,
      removeContainer: true,
      backgroundColor: null,
      imageTimeout: 15000,
      logging: true,
      scale: 2,
      useCORS: true,
    })
      .then((canvas) => {
        const contentDataURL = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = "Greetings-card.png";
        link.href = contentDataURL;
        link.click();
        window.gtag("event", "DOWNLOAD_EMPLOYEE_CARD");
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong.Please Try again.");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPageData();
  }, []);

  const fetchPageData = async () => {
    try {
      const response = await fetch(Urls.pages);

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          setLoader(false);
          setPageData(data.data);
        } else {
          console.error("API response status is not success:", data.error);
        }
      } else {
      }
    } catch (error) {
      console.error("Error fetching occasions:", error);
    }
  };

  const shareImage = async () => {
    try {
      const dataUrl = await htmlToImage.toPng(domEl.current, {
        skipAutoScale: true,
      });
      await handleSharePicture(dataUrl);
      window.gtag("event", "Share_Employee");
    } catch (error) {
      toast.error("Unable to share the image.");
      console.error("Error sharing image:", error);
    }
  };

  return (
    <>
      <div className="relative w-full min-h-screen flex justify-center items-center flex-col px-4 md:py-10 py-5">
        <div className="flex-grow flex flex-col items-center justify-center">
          <img
            className="hidden md:block absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
            src={pageData?.banner}
            alt=""
          />
          <img
            className="md:hidden absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
            src={pageData?.thumb}
            alt=""
          />

          <img
            className="brand_logo w-[70px] md:w-[100px] xl:w-[143px] 2xl:w-[170px] xl:mb-10 mb-7"
            src={
              i18n.language === "en" || i18n.language === undefined
                ? `/berger-logo.png`
                : `/berger-logo-bn.png`
            }
            alt=""
          />

          <div className="flex justify-center items-center flex-col max-w-[400px]">
            {loader ? (
              <div className="relative w-full h-[100px]">
                <svg className="spinner" viewBox="0 0 50 50">
                  <circle
                    className="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    strokeWidth="5"
                  ></circle>
                </svg>
              </div>
            ) : (
              <>
                <div
                  id="domEl"
                  ref={domEl}
                  className="relative box-shadow flex justify-center items-center"
                >
                  <img src={pageData?.card} alt="card" className="eid-card" />

                  <Draggable axis="both" bounds="parent" scale={1}>
                    <div
                      style={{ color: "#231F20", cursor: "pointer" }}
                      className="absolute text-center"
                    >
                      <h2 className="!text-[#272727] text-[14px] xl:text-[16px] font-bold leading-[1.12]">
                        {state?.name}
                      </h2>
                      <p className="!text-[#272727] text-[12px] xl:text-[14px] leading-[1] mb-[2px] ">
                        {state?.designation}
                      </p>
                      <p className="!text-[#272727] text-[12px] xl:text-[14px] leading-[1] mb-[2px] ">
                        {state?.department}
                      </p>
                      <p className="!text-[#272727] text-[10px] xl:text-[12px] leading-[1]">
                        {state?.company}
                      </p>
                    </div>
                  </Draggable>
                </div>
                <div className="flex md:flex-row flex-col items-center justify-center gap-4 w-full mt-6">
                  <Link
                    to="/"
                    type="button"
                    className=" md:w-1/2 w-full md:order-1 order-2 border border-[#00ADEE] bg-white text-center h-[50px] text-[#00ADEE] hover:text-[#00ADEE] transition-all duration-300 ease-in  font-bold rounded-full text-sm px-11 py-3"
                  >
                    {t("go-back")}
                  </Link>
                  <div className="md:w-1/2 w-full md:order-2 order-1 flex items-center gap-4">
                    <button
                      onClick={
                        isIOs ? downloadImageForiOs : downloadImageForAndroid
                      }
                      type="button"
                      className="bg-[#00ADEE]  w-[calc(100%-58px)] h-[50px] text-white hover:text-white hover:bg-[#00aeeec5] transition-all duration-300 ease-in  font-bold rounded-full text-sm text-center"
                      disabled={loading}
                    >
                      {loading ? t("downloading") : t("download")}
                    </button>
                    <button
                      className="w-[50px] h-[50px] rounded-full flex justify-center items-center bg-[#00ADEE]"
                      onClick={shareImage}
                    >
                      <ShareIcon />
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="md:pt-10 pt-5 text-center text-sm">
          <span className="text-white">©</span>
          2025 Berger Paints Bangladesh Limited. All Rights Reserved.
        </div>
      </div>
    </>
  );
};

export default EmployeeCardPreview;
